export const Logo = ({ size = 38 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Tim Wanyonyi campaign mark"
  >
    <rect width="64" height="64" rx="14" fill="#0B0C10" stroke="rgba(255,87,34,0.45)" strokeWidth="1.5" />
    <path d="M15 37 A17 17 0 0 1 49 37 Z" fill="#FF5722" />
    <rect x="10" y="38.5" width="44" height="3" rx="1.5" fill="#D4AF37" />
    <text
      x="32"
      y="56"
      textAnchor="middle"
      fontFamily="Syne, sans-serif"
      fontWeight="800"
      fontSize="14"
      fill="#F3F4F6"
      letterSpacing="1"
    >
      TW
    </text>
  </svg>
);
